import { render, staticRenderFns } from "./ChannelManager.vue?vue&type=template&id=485114c8&scoped=true"
import script from "./ChannelManager.vue?vue&type=script&lang=js"
export * from "./ChannelManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485114c8",
  null
  
)

export default component.exports